import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

const RoofSnapConfirmationDialog = (props) => {
    const handleConfirmClick = () => {
        props.onConfirmClick();
        props.onDismissClick();
    };

    return (
        <Dialog
            open={props.open}
            fullScreen={props.fullScreen}
        >
            <DialogTitle>
                {props.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.message}
                </DialogContentText>
                {props.content}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={props.onDismissClick}
                >
                    Dismiss
                </Button>
                <Button
                    onClick={handleConfirmClick}
                    color="secondary"
                >
                    {props.confirmButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

RoofSnapConfirmationDialog.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onConfirmClick: PropTypes.func.isRequired,
    onDismissClick: PropTypes.func.isRequired,
    confirmButtonText: PropTypes.string,
    content: PropTypes.node,
};

RoofSnapConfirmationDialog.defaultProps = {
    confirmButtonText: 'Confirm',
    content: null,
};

export default RoofSnapConfirmationDialog;